export default __webpack_public_path__ + "static/media/food.d1513afa.jpg";